import { AUTO_UPDATE_TOOLTIP } from '../constants/indicatorLoadMonitoring';
import type {
  TIndicatorItemDto,
  TIndicatorPage,
  TIndicatorPageDto,
  TIndicatorRow,
} from '../store/indicatorLoadMonitoring/types';

/**
 * Приводит данные item к табличному виду
 */
const prepareIndicatorRow = (raw: TIndicatorItemDto): TIndicatorRow => {
  return {
    ...raw,
    name: { title: raw.name, tooltip: raw.isIntegration ? AUTO_UPDATE_TOOLTIP : '' },
    plannedUpdateDate: raw.plannedUpdateDate ?? '',
  };
};

export const prepareIndicatorPage = (raw: TIndicatorPageDto): TIndicatorPage => ({
  ...raw,
  items: raw.items.map(prepareIndicatorRow),
});
